export interface RewardCardImageInterface {
  imageUrl: string
}

export const theme: RewardCardImageInterface = {
  imageUrl:
    'https://s1.thcdn.com/design-assets/whitelabel/components/rewardCard.jpg',
}
